import { render, staticRenderFns } from "./amountCard.vue?vue&type=template&id=4b2098c1&scoped=true&"
import script from "./amountCard.vue?vue&type=script&lang=js&"
export * from "./amountCard.vue?vue&type=script&lang=js&"
import style0 from "./amountCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./amountCard.vue?vue&type=style&index=1&id=4b2098c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2098c1",
  null
  
)

export default component.exports